import { render, staticRenderFns } from "./addAudio.vue?vue&type=template&id=c09faecc"
import script from "./addAudio.vue?vue&type=script&lang=js"
export * from "./addAudio.vue?vue&type=script&lang=js"
import style0 from "./addAudio.vue?vue&type=style&index=0&id=c09faecc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports